module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "skynet.be"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/internet/free_email.js
// module id = 3327
// module chunks = 1609